import { render, staticRenderFns } from "./KETEditTrainer.vue?vue&type=template&id=36501be8&"
import script from "./KETEditTrainer.vue?vue&type=script&lang=js&"
export * from "./KETEditTrainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports